import React, { useState, useEffect } from "react";
import propTypes from "prop-types";
import OutsideClickHandler from "react-outside-click-handler";
import ArrowDown from "../../../assets/icons/arrow-down.svg";
import ArrowUp from "../../../assets/icons/arrow-up.svg";
function DropDown({
  placeholder,
  options,
  setUpdatedOptions,
  type,
  width,
  readonly,
  showLabel,
  setShowLabel,
  value,
  setValue,
  padding,
  centreId,
  setCourseId,
  forCourses,
}) {
  const [open, setOpen] =
    useState(false); /* State to  show and hide dropdown box*/
  const [searchResult, setSearchResult] =
    useState(options); /* To store Array of search result and array init*/
  const [optionLength, setOptionLength] = useState(searchResult?.length);
  // const [valueCourse, setValueCourse]=useState("");
  /* handler to find if searched key is present in array*/
  const handleInput = e => {
    const searchedWrd = e.target.value;
    // setValueCourse(e.target.value);
    setValue(e.target.value);
    const newFilter = options?.filter(value => {
    
      return value.centreName
        .toLowerCase()
        .includes(searchedWrd.toLowerCase());
      
    });
    setOpen(true);
    /* If not search not present in else append li saying not present */
    if (newFilter?.length != 0) {
      setSearchResult(newFilter);
      setOptionLength(searchResult?.length);
    } else {
      setSearchResult(options);
      setOptionLength(newFilter.length);
    }
  };
  const handleClick = () => {
    setOpen(!open);
    if (readonly === true) {
      setOpen(false);
    }
  };
  const outSideClickHandler = () => {
    setOpen(false);
  };
  const handleCreateObject = val => {
   
    options.push({
      centreId: (searchResult.length + 1).toString(),
      centreName: val.toString(),
    }); //push new values to update options
    setUpdatedOptions(options);
    // fetchData_forTag();
    
  };
  /* to show labels*/
  const handleLabel = label => {
    setValue(label);
    if (!showLabel.includes(label)) {
      setShowLabel(oldlabel => oldlabel.concat(label));
      setUpdatedOptions(oldlabel => oldlabel.concat(label));
    }
  };
  const handleCourseId = id => {
    if (!centreId?.includes(id)) {
      centreId ? setCourseId(oldlabel => oldlabel.concat(id)) : "";
    }
  };
  const removeLabel = remLab => {
    setShowLabel(
      showLabel.filter(function (f) {
        return f !== remLab;
      }),
    );
  };
  const removeid = remLab => {
    setCourseId(
      centreId.filter(function (f) {
        return f !== remLab;
      }),
    );
  };
  const renderOption = liData => {
    if (type == "multiselect") {
      if (optionLength != 0) {
        return liData?.map(item => (
          <li
            key={item.postId || item.centreId}
            className="font-ibm text-sm text-black font-medium opacity-60 py-1 cursor-pointer hover:bg-gray-200 px-4 capitalize"
            onClick={() => {
              handleLabel(item.centreName);
              handleCourseId(item.centreId);
            }}>
            {item.centreName}
          </li>
        ));
      } else {
        return (
          <button
            className="font-ibm text-sm text-black font-medium opacity-60 py-1 cursor-pointer hover:bg-gray-200 px-4 capitalize"
            disabled ={forCourses}
            onClick={() => {
              handleCreateObject(value), handleLabel(value);
            }}>
            {!forCourses ? `{Click here to create &quot;${value}&quot;}` : "No Record Found" }
          </button>
        );
      }
    }else {
      return (
        <li className="font-ibm text-sm text-black font-medium opacity-60 py-1 px-4 capitalize">
        No Record Found
        </li>
      );
    }
  };
  
  useEffect(() => {
    
    if (setUpdatedOptions) {
      setUpdatedOptions(showLabel); //to send set option values to fontend
    }
    
  }, [value, showLabel]);
  useEffect(() => {
    setSearchResult(options);
  }, [options]);

  return (
    <div className=" flex justify-between">
      <OutsideClickHandler onOutsideClick={outSideClickHandler}>
        {(type == "singleSelect" || type == "multiselect") && (
          <div className={`${width} relative top-0`}>
            <input
              className={`ml-5  bg-white border-2 border-secondary-300 rounded-2xl pl-4 pr-5 py-${
                padding ? 0 : 3
              } border-solid  px-2 focus:outline-none w-full cursor-pointer focus:placeholder-transparent font-semibold placeholder-bold`}
              type="text"
              placeholder={placeholder}
              value={value}
              onChange={handleInput}
              onClick={handleClick}
              readOnly={
                type === "singleSelect" && readonly === true ? true : false
              }
            />
            <span
              onClick={handleClick}
              className={`absolute opacity-70 -right-2 cursor-pointer top-${
                padding ? 0 : 3
              }`}>
              <img src={open === true ? ArrowUp : ArrowDown} />
            </span>
            {open === true && (
              <div className="ml-5">
                <ul
                  className={`h-auto pt-2 w-full border-0 border-secondary-300 rounded-2xl pl-4 pr-5 py-3 border-solid px-2 shadow-lg absolute z-50 top-14 bg-white scrollbar-thin overflow-y-scroll scrollbar-thumb-secondary-700 scrollbar-thumb-rounded max-h-[10rem] ${
                    type == "multiselect" ? "mb-[2rem]" : "mb-5"
                  }`}>
                  {options?.length>0?renderOption(searchResult):"No Record found"}
                </ul>
              </div>
            )}
          </div>
        )}
      </OutsideClickHandler>
      {type === "multiselect" && (
        <div className="w-[36rem] ml-9 flex mt-2 flex-wrap">
          {showLabel.map((lab, l) => (
            <div key={l} className=" relative mr-1 mb-5">
              <span className="bg-gray-100 text-sm text-black rounded-full px-3 pr-6 pt-3 pb-2 capitalize whitespace-nowrap">
                {lab}
              </span>
              {centreId &&
                centreId.map((id, l) => (
                  <span
                    key={l}
                    className="absolute bottom-[3px] text-xs font-medium cursor-pointer right-2 text-gray-500"
                    onClick={() => {
                      removeLabel(lab);
                      removeid(id);
                    }}>
                    &#10005;
                  </span>
                ))}
              {!centreId && (
                <span
                  key={l}
                  className="absolute bottom-[3px] text-xs font-medium cursor-pointer right-2 text-gray-500"
                  onClick={() => {
                    removeLabel(lab);
                  }}>
                  &#10005;
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
DropDown.propTypes = {
  placeholder: propTypes.string,
  options: propTypes.array,
  setUpdatedOptions: propTypes.func,
  setShowLabel: propTypes.func,
  type: propTypes.string,
  width: propTypes.string,
  setFieldValue: propTypes.func,
  readonly: propTypes.bool,
  showLabel: propTypes.array,
  value: propTypes.any,
  setValue: propTypes.func,
  setValId: propTypes.func,
  blog_post: propTypes.func,
  fetchGetBlogPost: propTypes.func,
  padding: propTypes.any,
  centreId: propTypes.array,
  setCourseId: propTypes.func,
  forCourses : propTypes.bool,
};
export default DropDown;
